module.exports = __webpack_public_path__ + "img/prepare-remove-btn-disabled.febec022.svg";